// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const ForecastingPage = lazy(() => import('./pages/ForecastingPage'));
const InventoryOptimizationPage = lazy(() => import('./pages/InventoryOptimizationPage'));
const SafetyStockPage = lazy(() => import('./pages/SafetyStockPage'));
const LeadTimeFactorPage = lazy(() => import('./pages/LeadTimeFactorPage'));
const ScenariosPage = lazy(() => import('./pages/ScenariosPage'));

export const DemandRoutes: RouteObject = {
  path: 'demand',
  element: <ModuleGuard moduleId="operations.demand" />,
  children: [
    { path: 'forecasting', element: <ForecastingPage />, handle: { crumb: 'Forecasting' } },
    { path: 'inventory-optimization', element: <InventoryOptimizationPage />, handle: { crumb: 'Inventory Optimization' } },
    { path: 'safety-stock', element: <SafetyStockPage />, handle: { crumb: 'Safety Stock' } },
    { path: 'lead-time-factor', element: <LeadTimeFactorPage />, handle: { crumb: 'Lead Time Factor' } },
    { path: 'scenarios', element: <ScenariosPage />, handle: { crumb: 'Scenarios' } },
  ],
};
